import { Edge } from "reactflow";

export const initialEdges: Edge[] = [
  // { id: "e1-2", source: "1", target: "2", type: "step", animated: true },
  // { id: "e1-3", source: "1", target: "3", type: "step" },
  // { id: "e2-4", source: "2", target: "4", type: "step" },
  // { id: "e2-5", source: "2", target: "5", type: "step" },
];
